import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Devices, DeviceStatusDialogState } from "../../../types/Device.types";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";
import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";
import { getLocalizedDeviceName } from "../utils/getLocalizedDeviceName";

import { getTestResultStatus } from "./utils/getTestResultStatus";
import { DeviceStatusDialogBox } from "./DeviceStatusDialogBox";
import { dialogStateToDeviceName } from "./DeviceStatusDialogBox.types";

export const ConnectedDeviceStatusDialogBox: React.FC = () => {
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();
  const { deviceTesterState } = useDeviceTesterStateContext();

  const { isMobile } = usePlatformTypeContext();
  const { t } = useTranslation();

  const deviceName =
    dialogStateToDeviceName[deviceTesterState.deviceStatusDialogState];
  const deviceNameString = getLocalizedDeviceName(deviceName, t, true);

  let deviceResult;
  if (deviceName === Devices.Camera) {
    deviceResult = deviceTesterState.cameraResult;
  } else if (deviceName === Devices.Speaker) {
    deviceResult = deviceTesterState.speakerResult;
  } else if (deviceName === Devices.Mic) {
    deviceResult = deviceTesterState.microphoneResult;
  } else if (deviceName === Devices.Network) {
    deviceResult = deviceTesterState.networkResult;
  }

  const { statusView } = getTestResultStatus(
    deviceResult,
    deviceNameString,
    isMobile,
    t
  );

  const closeDialog = useCallback(() => {
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_STATUS_DIALOG_STATE,
      deviceStatusDialogState: DeviceStatusDialogState.CLOSED,
    });
  }, [deviceTesterDispatch]);

  return (
    <DeviceStatusDialogBox
      deviceName={deviceName}
      isDialogOpen={
        deviceTesterState.deviceStatusDialogState !==
        DeviceStatusDialogState.CLOSED
      }
      closeDialog={closeDialog}
      isMobile={isMobile}
      status={deviceResult?.status}
      statusDetail={statusView}
    />
  );
};
